// extracted by mini-css-extract-plugin
export var backButton = "_s-1";
export var content = "_s-d";
export var continueButton = "_s-7";
export var continueHint = "_s-8";
export var continueRow = "_s-6";
export var leftInner = "_s-0";
export var shell = "_s-e";
export var sidebarContent = "_s-5";
export var skipButton = "_s-c";
export var spacer = "_s-2";
export var spin = "_s-a";
export var spinner = "_s-9";
export var spinnerOverlay = "_s-b";
export var subtitle = "_s-4";
export var title = "_s-3";